'use strict';

var beacon = function beacon(url) {
  return function (payload) {
    return fetch(url, {
      method: 'POST',
      headers: [['Content-Type', 'application/json']],
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) {
        console.error("HTTP error! status: " + response.status);
      }
      return 'Accepted';
    });
  };
};
var beacon$1 = beacon;

module.exports = beacon$1;
//# sourceMappingURL=beacon.js.map
